import { Flex } from "@chakra-ui/react";
import Router from "next/router";
import { useTranslation } from "react-i18next";

import { OFButton } from "design_system/components/OFButton";
import { OFText } from "design_system/components/OFText";
import { ExploreIcon } from "design_system/icons";
import { colors } from "src/colors";
import { URL_EXPLORE } from "src/constants/url.constants";

export const EmptyCart = () => {
  const { t } = useTranslation();
  return (
    <Flex
      p={["16px 12px", null, "32px 24px"]}
      flexDirection="column"
      alignItems="center"
      gap="16px"
      bg={colors.white.default}
      w="max-content"
      borderRadius="8px"
      alignSelf="center"
    >
      <Flex gap="40px" flexDirection="column" alignItems="center">
        <OFText textStyle="h3">{t("checkout:empty_cart_title")}</OFText>
        <ExploreIcon size={120} color={colors.orange[400]} />
        <OFText textStyle="body2">{t("checkout:empty_cart_description")}</OFText>
      </Flex>
      <OFButton onClick={() => Router.push(URL_EXPLORE)}>
        {t("checkout:empty_cart_button_text")}
      </OFButton>
    </Flex>
  );
};
